var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { TabStripNavigationItem } from './TabStripNavigationItem';
import { classNames } from '@progress/kendo-react-common';
import { Button } from '@progress/kendo-react-buttons';
/**
 * @hidden
 */
var times = function (count) { return Array.apply(null, Array(count)); };
var preventDefault = function (e) { return e.preventDefault(); };
var DEFAULT_SCROLL_BEHAVIOR = 'smooth';
var PREV = 'prev';
var NEXT = 'next';
var TabStripNavigation = /** @class */ (function (_super) {
    __extends(TabStripNavigation, _super);
    function TabStripNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this.itemsNavRef = React.createRef();
        _this.onWheel = function (event) {
            event.stopPropagation();
            var direction = event.deltaY < 0 ? PREV : NEXT;
            _this.setNewScrollPosition(direction, event);
        };
        _this.arrowClickPrev = function (e) {
            _this.handleArrowClick(PREV, e);
        };
        _this.arrowClickNext = function (e) {
            _this.handleArrowClick(NEXT, e);
        };
        _this.handleArrowClick = function (direction, e) {
            _this.setNewScrollPosition(direction, e);
        };
        _this.setNewScrollPosition = function (direction, e) {
            var list = _this.itemsNavRef.current;
            if (!list) {
                return;
            }
            var horizontal = _this.horizontalScroll();
            var scrollEnd = horizontal ? list.scrollWidth - list.offsetWidth : list.scrollHeight - list.offsetHeight;
            var increment = (e.type === 'click' ? _this.props.buttonScrollSpeed : _this.props.mouseScrollSpeed) || 0;
            var prevScrollPosition = horizontal ? list.scrollLeft : list.scrollTop;
            if (direction === PREV && prevScrollPosition > 0) {
                prevScrollPosition -= increment;
            }
            if (direction === NEXT && prevScrollPosition < scrollEnd) {
                prevScrollPosition += increment;
            }
            prevScrollPosition = Math.max(0, Math.min(scrollEnd, prevScrollPosition));
            if (horizontal) {
                list.scrollTo({ left: prevScrollPosition });
                _this.setState({
                    disabledPrev: prevScrollPosition === 0,
                    disabledNext: Math.round(list.scrollWidth - list.scrollLeft) === list.clientWidth
                        || Math.floor(list.scrollWidth - list.scrollLeft) === list.clientWidth
                });
            }
            else {
                list.scrollTo({ top: prevScrollPosition });
                _this.setState({
                    disabledPrev: prevScrollPosition === 0,
                    disabledNext: Math.round(list.scrollHeight - list.scrollTop) === list.clientHeight
                        || Math.floor(list.scrollHeight - list.scrollTop) === list.clientHeight
                });
            }
        };
        _this.renderArrow = function (type, disabled) {
            var horizontal = _this.horizontalScroll();
            var directions = {
                prev: {
                    arrowTab: 'k-tabstrip-prev',
                    arrow: horizontal ? 'caret-alt-left' : 'caret-alt-up'
                },
                next: {
                    arrowTab: 'k-tabstrip-next',
                    arrow: horizontal ? 'caret-alt-right' : 'caret-alt-down'
                }
            };
            var ButtonComponent = (type === PREV ? _this.props.prevButton : _this.props.nextButton) || Button;
            var onClick = (type === PREV ? _this.arrowClickPrev : _this.arrowClickNext);
            return (React.createElement(ButtonComponent, { disabled: disabled, className: "".concat(directions[type].arrowTab), onClick: onClick, icon: directions[type].arrow, onMouseDown: preventDefault, tabIndex: -1, fillMode: "flat" }));
        };
        _this.state = {
            disabledPrev: _this.props.selected === 0,
            disabledNext: _this.props.selected === React.Children.count(_this.props.children) - 1
        };
        return _this;
    }
    /**
     * @hidden
     */
    TabStripNavigation.prototype.componentDidMount = function () {
        if (this.props.scrollable) {
            this.scrollToSelected();
        }
    };
    /**
     * @hidden
     */
    TabStripNavigation.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, scrollable = _a.scrollable, selected = _a.selected;
        if (scrollable && prevProps.selected !== selected) {
            this.scrollToSelected();
            this.setState({
                disabledPrev: selected === 0,
                disabledNext: selected === React.Children.count(this.props.children) - 1
            });
        }
    };
    /**
     * @hidden
     */
    TabStripNavigation.prototype.render = function () {
        var _a = this.props, selected = _a.selected, tabPosition = _a.tabPosition, children = _a.children, onSelect = _a.onSelect, onKeyDown = _a.onKeyDown;
        var tabsCount = React.Children.count(children);
        var childElements = React.Children.toArray(children);
        var tabs;
        if (children) {
            tabs = times(tabsCount).map(function (_, index, array) {
                var tabProps = {
                    active: selected === index,
                    disabled: childElements[index].props.disabled,
                    index: index,
                    title: childElements[index].props.title,
                    first: index === 0,
                    last: index === array.length - 1,
                    onSelect: onSelect
                };
                return React.createElement(TabStripNavigationItem, __assign({ key: index }, tabProps));
            });
        }
        var wrapperClasses = classNames('k-tabstrip-items-wrapper', {
            'k-hstack': tabPosition === 'top' || tabPosition === 'bottom',
            'k-vstack': tabPosition === 'left' || tabPosition === 'right'
        });
        var navClasses = classNames('k-tabstrip-items', 'k-reset');
        return (React.createElement("div", { className: wrapperClasses }, this.props.scrollable ? (React.createElement(React.Fragment, null,
            this.renderArrow(PREV, this.state.disabledPrev),
            React.createElement("ul", { ref: this.itemsNavRef, className: navClasses, role: 'tablist', tabIndex: this.props.tabIndex, onKeyDown: onKeyDown, onWheel: this.onWheel }, tabs),
            this.renderArrow(NEXT, this.state.disabledNext))) : (React.createElement("ul", { className: navClasses, role: 'tablist', tabIndex: this.props.tabIndex, onKeyDown: onKeyDown }, tabs))));
    };
    TabStripNavigation.prototype.scrollToSelected = function () {
        var _a, _b;
        var list = this.itemsNavRef.current;
        var tab = list && list.children[this.props.selected || 0];
        if (tab instanceof HTMLElement && list instanceof HTMLElement) {
            var horizontal = this.horizontalScroll();
            var currentScrollOffset = horizontal ? list.scrollLeft : list.scrollTop;
            var listSize = horizontal ? list.offsetWidth : list.offsetHeight;
            var tabOffset = horizontal ? tab.offsetLeft - list.offsetLeft : tab.offsetTop - list.offsetTop;
            var tabSize = horizontal ? tab.offsetWidth : tab.offsetHeight;
            var scrollDir = horizontal ? 'left' : 'top';
            var scrollPosition = 0;
            if (currentScrollOffset + listSize < tabOffset + tabSize) {
                scrollPosition = tabOffset + tabSize - listSize;
                list.scrollTo((_a = {}, _a[scrollDir] = scrollPosition, _a.behavior = DEFAULT_SCROLL_BEHAVIOR, _a));
            }
            else if (currentScrollOffset > tabOffset) {
                scrollPosition = tabOffset;
                list.scrollTo((_b = {}, _b[scrollDir] = scrollPosition, _b.behavior = DEFAULT_SCROLL_BEHAVIOR, _b));
            }
        }
    };
    TabStripNavigation.prototype.horizontalScroll = function () {
        return /top|bottom/.test(this.props.tabPosition || 'top');
    };
    /**
     * @hidden
     */
    TabStripNavigation.propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.arrayOf(PropTypes.element)
        ]),
        onSelect: PropTypes.func,
        onKeyDown: PropTypes.func,
        selected: PropTypes.number,
        tabIndex: PropTypes.number
    };
    return TabStripNavigation;
}(React.Component));
export { TabStripNavigation };
